module.exports = __webpack_public_path__ + "img/DIRECTOR_PENDING.6725c1df.svg";